(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page--faq--section-1"]) return;
  try {
    
  require([ 'jquery', 'domReady!' ], function ($) {
    // set up collapses

    var open = function ($el) {
      $el.height($el.data('height'));

      setTimeout(function () {
        $el.height('auto');
        $el.data('height', $el.height());
        $el.addClass('open')
      }, 300);
    }

    var close = function ($el) {
      $el.height($el.data('height'));
      $el.height('0px');

      setTimeout(function () {
        $el.removeClass('open')
      }, 300)
    }

    $('.is-collapsible .block-row-content').each(function () {
      var $el = $(this);
      $el.data('height', $el.height());
      close($el);
    })

    $('.is-collapsible .block-row').on('click', function () {
      close($('.block-row-content.open'));

      var $el = $(this).find('.block-row-content');
      $el.hasClass('open') ? close($el) : open($el);
    })
  });

  } catch(e) { console.error(e); }
})();
})();
